import { render } from "./RegisterFrom.vue?vue&type=template&id=9d6aa964"
import script from "./RegisterFrom.vue?vue&type=script&lang=js"
export * from "./RegisterFrom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__